if (!customElements.get('quick-add-bulk')) {
  customElements.define(
    'quick-add-bulk',
    class QuickAddBulk extends BulkAdd {
      constructor() {
        super();
        this.quantity = this.querySelector('quantity-input');

        // Producten met startaantal-2: 0 → 2 en 2 → 0.
        this.addEventListener(
          'click',
          (event) => {
            const button = event.target.closest(
              'button[name="plus"], button[name="minus"]'
            );
            if (!button || !this.contains(button)) return;

            const input = this.input;
            if (!input || input.dataset.startAtTwo !== 'true') return;

            const current = Number(input.value);
            let next;

            if (button.name === 'plus' && current === 0) {
              const step = Number(input.step) || 1;
              const minimum = Number(input.dataset.min) || 1;
              const maximum =
                input.max === '' ? Infinity : Number(input.max);

              if (step !== 1 || minimum > 2 || maximum < 2) return;

              next = 2;
            } else if (button.name === 'minus' && current === 2) {
              next = 0;
            } else {
              return;
            }

            event.preventDefault();
            event.stopImmediatePropagation();

            input.value = String(next);
            input.dispatchEvent(
              new Event('change', { bubbles: true })
            );
          },
          true
        );

        const debouncedOnChange = debounce((event) => {
          if (parseInt(event.target.value) === 0) {
            this.startQueue(
              event.target.dataset.index,
              parseInt(event.target.value)
            );
          } else {
            this.validateQuantity(event);
          }
        }, ON_CHANGE_DEBOUNCE_TIMER);

        this.addEventListener('change', debouncedOnChange.bind(this));
        this.listenForActiveInput();
        this.listenForKeydown();
        this.lastActiveInputId = null;
      }

      connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(
          PUB_SUB_EVENTS.cartUpdate,
          (event) => {
            if (
              event.source === 'quick-add' ||
              (event.cartData.items &&
                !event.cartData.items.some(
                  (item) => item.id === parseInt(this.dataset.index)
                )) ||
              (event.cartData.variant_id &&
                !(event.cartData.variant_id === parseInt(this.dataset.index)))
            ) {
              return;
            }

            // If another section made the update.
            this.onCartUpdate().then(() => {
              this.listenForActiveInput();
              this.listenForKeydown();
            });
          }
        );
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
      }

      get input() {
        return this.querySelector('quantity-input input');
      }

      selectProgressBar() {
        return this.querySelector('.progress-bar-container');
      }

      listenForActiveInput() {
        if (!this.classList.contains('hidden')) {
          this.input?.addEventListener(
            'focusin',
            (event) => event.target.select()
          );
        }
        this.isEnterPressed = false;
      }

      listenForKeydown() {
        this.input?.addEventListener('keydown', (event) => {
          if (event.key === 'Enter') {
            this.input?.blur();
            this.isEnterPressed = true;
          }
        });
      }

      cleanErrorMessageOnType(event) {
        event.target.addEventListener(
          'keypress',
          () => {
            event.target.setCustomValidity('');
          },
          { once: true }
        );
      }

      get sectionId() {
        if (!this._sectionId) {
          this._sectionId =
            this.closest('.collection-quick-add-bulk').dataset.id;
        }

        return this._sectionId;
      }

      onCartUpdate() {
        return new Promise((resolve, reject) => {
          fetch(`${this.getSectionsUrl()}?section_id=${this.sectionId}`)
            .then((response) => response.text())
            .then((responseText) => {
              const html = new DOMParser().parseFromString(
                responseText,
                'text/html'
              );
              const sourceQty = html.querySelector(
                `#quick-add-bulk-${this.dataset.index}-${this.sectionId}`
              );
              if (sourceQty) {
                this.innerHTML = sourceQty.innerHTML;
              }
              resolve();
            })
            .catch((e) => {
              console.error(e);
              reject(e);
            });
        });
      }

      getSectionsUrl() {
        const pageParams = new URLSearchParams(window.location.search);
        const pageNumber = decodeURIComponent(pageParams.get('page') || '');

        return `${window.location.pathname}${
          pageNumber ? `?page=${pageNumber}` : ''
        }`;
      }

      updateMultipleQty(items) {
        this.selectProgressBar().classList.remove('hidden');

        const ids = Object.keys(items);
        const body = JSON.stringify({
          updates: items,
          sections: this.getSectionsToRender().map(
            (section) => section.section
          ),
          sections_url: this.getSectionsUrl(),
        });

        fetch(`${routes.cart_update_url}`, {
          ...fetchConfig(),
          ...{ body },
        })
          .then((response) => {
            return response.text();
          })
          .then((state) => {
            const parsedState = JSON.parse(state);
            this.renderSections(parsedState, ids);
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'quick-add',
              cartData: parsedState,
            });
          })
          .catch(() => {
            // Existing error handling remains unchanged.
          })
          .finally(() => {
            this.selectProgressBar().classList.add('hidden');
            this.setRequestStarted(false);
          });
      }

      getSectionsToRender() {
        return [
          {
            id: `quick-add-bulk-${this.dataset.index}-${this.sectionId}`,
            section: this.sectionId,
            selector: `#quick-add-bulk-${this.dataset.index}-${this.sectionId}`,
          },
          {
            id: 'cart-icon-bubble',
            section: 'cart-icon-bubble',
            selector: '.shopify-section',
          },
          {
            id: 'CartDrawer',
            selector: '.drawer__inner',
            section: 'cart-drawer',
          },
        ];
      }

      renderSections(parsedState, ids) {
        const intersection = this.queue.filter(
          (element) => ids.includes(element.id)
        );
        if (intersection.length !== 0) return;

        this.getSectionsToRender().forEach((section) => {
          const sectionElement = document.getElementById(section.id);

          if (section.section === 'cart-drawer') {
            sectionElement
              .closest('cart-drawer')
              ?.classList.toggle(
                'is-empty',
                parsedState.items.length.length === 0
              );
          }

          const elementToReplace =
            sectionElement &&
            sectionElement.querySelector(section.selector)
              ? sectionElement.querySelector(section.selector)
              : sectionElement;

          if (elementToReplace) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          }
        });

        if (this.isEnterPressed) {
          this.querySelector(
            `#Quantity-${this.lastActiveInputId}`
          ).select();
        }

        this.listenForActiveInput();
        this.listenForKeydown();
      }
    }
  );
}
